import { useState } from 'react';
import api from '../services/api';

export const useBovedaSegura = () => {
    const [procesando, setProcesando] = useState(false);

    const obtenerUrlDocumento = async (rutaArchivo) => {
        if (!rutaArchivo) return null;

        try {
            setProcesando(true);

            const response = await api.get(rutaArchivo, { responseType: 'blob' });
            const fileBlob = response instanceof Blob ? response : new Blob([response]);
            const blobUrl = window.URL.createObjectURL(fileBlob);

            // 🚀 EXTRAEMOS EL FORMATO REAL DIRECTAMENTE DEL BINARIO
            return { blobUrl, trueMimetype: fileBlob.type };

        } catch (error) {
            console.error('[SEGURIDAD] Error al obtener documento:', error);
            return null;
        } finally {
            setProcesando(false);
        }
    };

    return { obtenerUrlDocumento, procesando };
};